/* Kezdőlap-beállítások (3a): az árszalag alapból ki; a fejléc 💾-menüjében kapcsolható. */
export const TICKER_KEY = 'w3k_ticker_on';
export const TICKER_EVENT = 'w3k:ticker-toggle';
export function tickerOn() {
  try { return localStorage.getItem(TICKER_KEY) === 'true'; } catch { return false; }
}
